/**
 * Leitura de um quadro repetido do posto (atividades, cargas, equipamentos...) pelo subrecurso.
 * Carregando, erro e lista ficam separados para a tela desenhar cada estado.
 */
import { useCallback, useEffect, useRef, useState } from 'react';
import { errorMessage } from './wizardValidation';

export function useItems<T>(load: () => Promise<T[]>, failure: string) {
  const [items, setItems] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Só a última leitura pedida vale: uma resposta atrasada de recarga anterior não sobrescreve a mais nova.
  const latest = useRef(0);

  const reload = useCallback(async () => {
    const mine = ++latest.current;
    setLoading(true);
    try {
      const loaded = await load();
      if (mine !== latest.current) return;
      setItems(loaded);
      setError(null);
    } catch (err: unknown) {
      if (mine !== latest.current) return;
      setError(errorMessage(err, failure));
    } finally {
      if (mine === latest.current) setLoading(false);
    }
  }, [load, failure]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { items, loading, error, reload };
}
